import { render, staticRenderFns } from "./TaskChecklistInDetail.vue?vue&type=template&id=25adfddf&scoped=true"
import script from "./TaskChecklistInDetail.vue?vue&type=script&lang=js"
export * from "./TaskChecklistInDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskChecklistInDetail.vue?vue&type=style&index=0&id=25adfddf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25adfddf",
  null
  
)

export default component.exports